import React from 'react'
function InvoiceItemHeaderStyle({signed_in}) {
  let receipt_link_display = 'block'
  if (signed_in !== 'admin') receipt_link_display = (signed_in.user_access.receipts) ? 'block' : 'none'

  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .content-header-content { display: flex; padding: 10px; }
        .header-title-caption {
          font-size: 1rem;
          display: flex;
          flex: 2;
          align-items: center;
        }

        #see-receipt-link { display: ${receipt_link_display}; }
      `}
      </style>
    </React.Fragment>
  )
}

export default React.memo(InvoiceItemHeaderStyle)
